(() => {
  const previewModal = document.querySelector('[data-pra-cart-preview-modal]');
  const previewImage = previewModal?.querySelector('[data-pra-cart-preview-image]');
  let previewScale = 1;
  let previewObjectUrl = '';
  let previewRequestId = 0;

  const releasePreviewUrl = () => {
    if (previewObjectUrl) URL.revokeObjectURL(previewObjectUrl);
    previewObjectUrl = '';
  };

  previewModal?.addEventListener('close', () => {
    previewRequestId += 1;
    previewImage?.removeAttribute('src');
    releasePreviewUrl();
  });

  const updatePreviewScale = () => {
    if (!previewImage) return;
    previewImage.style.transform = `scale(${previewScale})`;
    previewImage.style.transformOrigin = 'center center';
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-pra-cart-preview]');
    if (trigger && previewModal && previewImage) {
      // TeeInBlue injects a link around the thumbnail after the cart renders.
      // Keep the click inside our preview dialog instead of opening that link.
      event.preventDefault();
      event.stopPropagation();

      const requestId = ++previewRequestId;
      let cachedPreview = '';
      let objectUrl = '';
      if (trigger.dataset.customizationId) {
        if ('caches' in window) {
          try {
            const cache = await caches.open('pra-customization-previews-v1');
            const response = await cache.match(
              `/__pra_customization_preview__/${encodeURIComponent(trigger.dataset.customizationId)}`
            );
            if (response) {
              objectUrl = URL.createObjectURL(await response.blob());
              cachedPreview = objectUrl;
            }
          } catch (_error) {
            cachedPreview = '';
          }
        }
        try {
          cachedPreview =
            cachedPreview ||
            localStorage.getItem(`pra:customization-preview:${trigger.dataset.customizationId}`) || '';
        } catch (_error) {
          cachedPreview = '';
        }
      }
      // A slower previous click must not replace the most recently selected item.
      if (requestId !== previewRequestId) {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        return;
      }
      releasePreviewUrl();
      previewObjectUrl = objectUrl;
      previewImage.src = cachedPreview || trigger.dataset.previewSrc || '';
      previewImage.alt = trigger.dataset.previewAlt || 'Prévia do produto personalizado';
      previewScale = 1;
      updatePreviewScale();
      previewModal.showModal();
      return;
    }

    if (event.target.closest('[data-pra-cart-preview-zoom-in]')) {
      previewScale = Math.min(3, Number((previewScale + 0.25).toFixed(2)));
      updatePreviewScale();
      return;
    }

    if (event.target.closest('[data-pra-cart-preview-zoom-out]')) {
      previewScale = Math.max(0.75, Number((previewScale - 0.25).toFixed(2)));
      updatePreviewScale();
      return;
    }

    if (event.target.closest('[data-pra-cart-preview-close]')) previewModal?.close();
  });

  previewModal?.addEventListener('click', (event) => {
    if (event.target === previewModal) previewModal.close();
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest('.pra-v2-cart-preview-trigger[data-pra-cart-preview]');
    if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    trigger.click();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-pra-cart-discount]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input');
    const code = input?.value.trim();
    if (!code) {
      input?.focus();
      return;
    }
    const root = window.Shopify?.routes?.root || '/';
    window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root + 'cart')}`);
  });
})();
